
import ViewCreditDetails from "@dana/Components/ViewCredit/ViewCreditDetails";
import ViewCreditResultCount from "@dana/Components/ViewCredit/ViewCreditResultCount";
import ViewCreditSearchBy from "@dana/Components/ViewCredit/ViewCreditsSearchBy";
import ViewCreditTable from "@dana/Components/ViewCredit/ViewCreditTable";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import getCreditMomos, { GetCreditMemosParameter } from "@dana/Store/Data/ViewCredit/Handlers/ViewCreditHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LoadingSpinner } from "@insite/mobius/index";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


export interface ViewCreditsPageStyles {
    page?: MobiusPageProps;
    loaderWrapper?: InjectableCss;
}

export const viewCreditsPageStyles: ViewCreditsPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
        css: css`
            [data-test-selector="PageTitle"] {
                margin-bottom: 0;
            }
            padding: 0 16px 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 24px 32px;
                        `,
                        css`
                            padding: 0 40px 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    loaderWrapper: {
        css: css`
            display: flex;
            align-items: center;
            min-height: 250px;
            justify-content: center;
        `
    }
};
const mapStateToProps = (state: ApplicationStateDana) => ({
    session: getSession(state),
    viewCreditState: state.viewCreditState
});

const mapDispatchToProps = {
    getCreditMomos
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = viewCreditsPageStyles;
const ViewCreditsPage: React.FC<Props> = ({ id, viewCreditState, getCreditMomos }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    const getFilterParamsFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return {
            creditMemoNumber: params.get("creditMemoNumber") || undefined,
            primaryPONumber: params.get("primaryPONumber") || undefined,
            secondaryPoNumber: params.get("secondaryPoNumber") || undefined,
            partNumber: params.get("partNumber") || undefined,  
            creditMemoTotal: params.get("creditMemoTotal") || undefined,     
            fromDate: params.get("fromDate") || undefined,             
            toDate: params.get("toDate") || undefined,
            sortBy: params.get("sortBy") || undefined,
            sort: params.get("sort") || undefined,
        };
    }
    React.useEffect(() => {
         const filterParams = getFilterParamsFromUrl();
        getCreditMomos(filterParams as GetCreditMemosParameter);
    }, []);

    React.useEffect(() => {
        setIsLoading(viewCreditState?.isLoading);
    }, [viewCreditState]);


    return (
        <Page {...styles.page}>
            <ViewCreditResultCount/>
            <ViewCreditSearchBy/>
            {isLoading ? 
                <StyledWrapper {...styles.loaderWrapper}>
                <LoadingSpinner/> 
                </StyledWrapper>:  <ViewCreditTable/>}
            <Zone contentId={id} zoneName="ViewCredit" />
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ViewCreditsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const ViewCreditsPageContext = "ViewCreditsPage";
